import Measure from "react-measure";
import React, { Component, PropTypes } from "react";

import { NitroIcon } from "nitro-components";

import styled from "styled-components";
import { media, boolStyle } from "style-utils";

const FilterGroupBox = styled.section`
  max-width: 48%;
  background: ${props => props.theme.color.white};
  box-shadow: ${props => props.theme.boxShadow.filter};
  border-radius: 4px;
  overflow: hidden;
  padding: 7px;
  display: flex;
  flex-direction: row;
`;

const FilterGroupHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.color.secondary};
  font-family: ${props => props.theme.font.bold};
  margin-right: 10px;
`;

const Tab = styled.section`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 4px;
    margin: 0 4px;
    background: ${props => (props.selected ? props.theme.color.secondary : props.theme.color.border)};
    font-size: 12px;
    color: ${props => (props.selected ? props.theme.color.white : props.theme.color.base2)};
    cursor: pointer;
`;

const FilterTabs = styled.div``;

class InsightsTabFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabIndex: 0
    };
    this.onChangeTab = this.onChangeTab.bind(this);
  }

  onChangeTab = (item, index) => {
    this.setState(
      {
        selectedTabIndex: index
      },
      this.props.onChangeTab(item.params)
    );
  };

  render() {
    const { filters } = this.props;
    return (
      <FilterGroupBox>
        <FilterGroupHeader>
          <NitroIcon
            name="filter-search"
            size={22}
            variant="secondary"
            left={10}
            right={10}
            top={-1}
          />
          <span>View By:</span>
        </FilterGroupHeader>
        <FilterTabs>
          {filters &&
            filters.map((item, index) => (
              <Tab
                key={index}
                selected={this.state.selectedTabIndex === index}
                onClick={() => this.onChangeTab(item, index)}
              >
                {item.label}
              </Tab>
            ))}

        </FilterTabs>
      </FilterGroupBox>
    );
  }
}

InsightsTabFilter.propTypes = {
  filters: PropTypes.array,
  selectedTabIndex: PropTypes.number,
  onChangeTab: PropTypes.func
};

export default InsightsTabFilter;



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightsTabFilter.js